import {
    APPSFLYER_BANNER_KEY,
    BOOKING_CONFIG_KEY,
    ENABLE_CROSS_BORDER_KEY,
    ENABLE_DELIVERY_TO_STORE,
    ENABLE_NEWSLETTER_BOOST_OPT_IN_OFFER_KEY,
    ENABLE_NOTIFY_ME_KEY,
    ENABLE_PRICE_LEGAL_MENTIONS,
    ENABLED_SWOGO_CONFIG_KEY,
    LOCALITIES_CONFIG_KEY,
    LOYALTY_CONFIGS_KEY,
    MINI_SIZE_CONFIG_KEY,
    MODERATION_LIST_KEY,
    NOTIFY_ME_DISABLED_COUNTRIES_KEY,
    OMNIBUS_INFORMATION_KEY,
    PROMO_STANDARD_TEXT_KEY,
    RED_DOT_CONFIGS_KEY,
    TOTAL_FOR_FREE_SHIPPING,
    VIP_BRANDS_KEY,
} from '../../../server/lib/config';
import { TARGET_2_SELL_CONFIG_KEY } from './target2Sell';

export const EcomConfigKeys = {
    BooxiApiKey: BOOKING_CONFIG_KEY,
    WoosmapApiKey: LOCALITIES_CONFIG_KEY,
    LoyaltyConfig: LOYALTY_CONFIGS_KEY,
    SmartBannerKey: APPSFLYER_BANNER_KEY,
    EnableNewsletterBoostOptInOffer: ENABLE_NEWSLETTER_BOOST_OPT_IN_OFFER_KEY,
    ProductPriceShippingThreshold: TOTAL_FOR_FREE_SHIPPING,
    EnablePriceLegalMentions: ENABLE_PRICE_LEGAL_MENTIONS,
    VipBrands: VIP_BRANDS_KEY,
    EnableCrossBorder: ENABLE_CROSS_BORDER_KEY,
    EnableCrossSellsBundles: ENABLED_SWOGO_CONFIG_KEY,
    EnableDeliveryToStore: ENABLE_DELIVERY_TO_STORE,
    ModerationList: MODERATION_LIST_KEY,
    EnableNotifyMe: ENABLE_NOTIFY_ME_KEY,
    NotifyMeDisabledCountries: NOTIFY_ME_DISABLED_COUNTRIES_KEY,
    RedDotConfig: RED_DOT_CONFIGS_KEY,
    T2SConfig: TARGET_2_SELL_CONFIG_KEY,
    MiniSizeConfig: MINI_SIZE_CONFIG_KEY,
    OmnibusInformation: OMNIBUS_INFORMATION_KEY,
    PromoStandardText: PROMO_STANDARD_TEXT_KEY,
} as const;

export type EcomConfigKeys = (typeof EcomConfigKeys)[keyof typeof EcomConfigKeys];
